import { LocalStorageKey } from 'src/core/constants/storage';
import { getLocalItem } from 'src/core/utils/storage';

/**
 * Experimental feature - only for internal use
 */
export function useDarkMode() {
  const isDarkModeEnabled = getLocalItem(LocalStorageKey.GRAPES_THEME, true);
  if (isDarkModeEnabled === 'dark') {
    document.documentElement.dataset.theme = 'dark';
  }
}
